export default __webpack_public_path__ + "static/media/polygonscan.638bc893.svg";